import React, { forwardRef } from "react";
import FormFieldWrapper from "./FormFieldWrapper";
import { twMerge } from "tailwind-merge";

const FormField = forwardRef(
  ({ label, wrapperClassName, wrapperProps, ...props }, ref) => {
    if (props.type === "select") {
      return (
        <FormFieldWrapper className={wrapperClassName} {...wrapperProps}>
          {label && (
            <label className=" font-medium" htmlFor={props.id}>
              {label}
            </label>
          )}
          <select
            {...props}
            ref={ref}
            className="border border-indigo-700 rounded p-2 select focus:outline-none focus:ring-1 focus:ring-indigo-900"
          >
            {props?.children}
          </select>
        </FormFieldWrapper>
      );
    }

    return (
      <FormFieldWrapper className={wrapperClassName} {...wrapperProps}>
        {label && (
          <label className="font-medium text-left text-sm" htmlFor={props.id}>
            {label}
          </label>
        )}
        <input
          {...props}
          ref={ref}
          className={twMerge(
            "border border-indigo-700 rounded p-2 focus:outline-none focus:ring-1 focus:ring-indigo-900",
            props?.className
          )}
        />
      </FormFieldWrapper>
    );
  }
);

FormField.displayName = "FormField";

export default FormField;
